import React, { ReactNode, useEffect, useRef } from 'react';
import { useProvidersForAngular } from './useProvidersForAngular';

export function WebComponentRenderer<T>({
  className = '',
  elementSelector,
  children,
  ...props
}: { className?: string; children: ReactNode; elementSelector: string } & T) {
  const webComponentProps = useRef({ props });

  const providers = useProvidersForAngular();

  Object.assign(webComponentProps.current.props, {
    ...props
  });

  useEffect(() => {
    const webComponent = document.querySelector(elementSelector);
    (webComponent as any).props = {
      properties: webComponentProps.current.props,
      providers
    };
  }, []);

  return (
    <>{children}</>
  );
}
